/*******************************************************
 標高タイルのエリア
   DEMLoadFunc.DEMAREA
   DEMLoadFunc.DEMAREA2
   DEMLoadFunc.DEMAREA3
   ※それぞれ上記ハッシュにコピーされ
   CONFIG.DEMAREA,CONFIG.DEMAREA2,CONFIG.DEMAREA3は削除される
*******************************************************/
const CONFIG_DEMAREA = [
  "8/215/108",
  "8/215/109",
  "8/215/110",
  "8/216/108",
  "8/216/109",
  "8/216/110",
  "8/217/109",
  "8/218/107",
  "8/218/108",
  "8/219/101",
  "8/219/102",
  "8/219/103",
  "8/219/104",
  "8/219/105",
  "8/219/106",
  "8/219/107",
  "8/219/108",
  "8/220/101",
  "8/220/102",
  "8/220/103",
  "8/220/104",
  "8/220/105",
  "8/220/106",
  "8/220/107",
  "8/221/101",
  "8/221/102",
  "8/221/103",
  "8/221/104",
  "8/221/105",
  "8/221/108",
  "8/221/109",
  "8/221/110",
  "8/221/99",
  "8/222/100",
  "8/222/101",
  "8/222/102",
  "8/222/103",
  "8/223/100",
  "8/223/101",
  "8/223/102",
  "8/224/100",
  "8/224/101",
  "8/224/102",
  "8/224/113",
  "8/224/99",
  "8/225/100",
  "8/225/101",
  "8/225/102",
  "8/225/98",
  "8/225/99",
  "8/226/100",
  "8/226/101",
  "8/226/102",
  "8/226/98",
  "8/226/99",
  "8/227/100",
  "8/227/101",
  "8/227/102",
  "8/227/103",
  "8/227/104",
  "8/227/105",
  "8/227/93",
  "8/227/94",
  "8/227/95",
  "8/227/96",
  "8/227/97",
  "8/227/98",
  "8/227/99",
  "8/228/100",
  "8/228/107",
  "8/228/108",
  "8/228/109",
  "8/228/110",
  "8/228/91",
  "8/228/92",
  "8/228/93",
  "8/228/94",
  "8/228/95",
  "8/228/96",
  "8/228/97",
  "8/228/98",
  "8/228/99",
  "8/229/107",
  "8/229/108",
  "8/229/91",
  "8/229/92",
  "8/229/93",
  "8/229/94",
  "8/229/95",
  "8/229/97",
  "8/230/92",
  "8/230/93",
  "8/230/94",
  "8/231/92",
  "8/231/93",
  "8/231/94",
  "8/232/91",
  "8/232/92",
  "8/232/93",
  "8/233/91",
  "8/233/92",
  "8/237/110",
];
const CONFIG_DEMAREA2 = [
  "9/442/198",
  "9/438/202",
  "9/438/203",
  "9/439/202",
  "9/439/203",
  "9/457/182",
  "9/458/182",
  "9/442/197",
];
const CONFIG_DEMAREA3 = ["10/879/406", "10/879/407"];

/*******************************************************
 DEMLoadFunc
    標高タイル読込
    自分で作る標高図・断面図などで利用
    3D版は別ファイル（leafletの機能を使わない）
*******************************************************/
export default {
  initialize,
  load,
};

// 初期化
function initialize(x, y, z) {
  this._initHooksCalled = true;
  this._coords = {
    x: x,
    y: y,
    z: z,
  };
}

function load(loader, self) {
  if (!loader._globalTileRange) {
    var bounds = getProjectedBounds(loader._tileZoom);
    if (bounds) loader._globalTileRange = _pxBoundsToTileRange(bounds);
  }
  this._globalTileRange = loader._globalTileRange;

  loader._demData = null;
  loader._demLoaded = false;
  loader._currentCoords = Object.assign({}, loader._coords);

  loader._urlList = getURLList(
    loader._coords.x,
    loader._coords.y,
    loader._coords.z
  );

  _startLoadDEM(loader, self);
}

/**
 * 標高データ取得
 * @param {*} urlList
 * @param {*} coords
 * @param {*} loader
 * @param {*} self
 */
function _loadDEM(urlList, coords, loader, self) {
  var options = {
    minZoom: 8,
    overZooming: true,
    useHillshademap: false,
    tms: false,
  };

  var z = coords.z;

  var targetUrl = null;
  while (urlList.length > 0) {
    var urlInfo = urlList.shift();
    if (urlInfo.minZoom <= z && z <= urlInfo.maxZoom) {
      targetUrl = Object.assign({}, urlInfo);
      break;
    }
  }

  if (!targetUrl) {
    if (z > 0 && options.overZooming) {
      _nextZoom(loader, self);
    } else {
      _demLoadError(loader);
    }
    return;
  }

  var url = getDEMTileUrl(targetUrl.url, coords, loader);

  if (!url) {
    throw new Error(getErrorMsg(self.riverInfo.sys, "ER003"));
  }

  loader._demImage = document.createElement("img");
  loader._demImage.addEventListener(
    "load",
    function() {
      _demLoadSuccess(urlList, coords, targetUrl, loader, self);
    },
    false
  );
  loader._demImage.addEventListener(
    "error",
    function() {
      _loadDEM(urlList, coords, loader);
    },
    false
  );

  loader._demImage.setAttribute("crossOrigin", "anonymous");
  loader._demImage.setAttribute("role", "presentation");
  loader._demImage.src = url;
}

function _demLoadError(loader) {
  loader._demLoaded = true;
  _checkLoaded(loader);
}

// 読み込み完了後解析
function _demLoadSuccess(urlList, coords, targetUrl, loader) {
  var scale = 1;
  var lt = null;
  var point = null;
  var idx = 0;
  var destIdx = 0;
  if (loader._coords.z != coords.z) {
    scale = Math.pow(2, loader._coords.z - coords.z);

    lt = toPoint(coords.x * 256 * scale, coords.y * 256 * scale);

    point = toPoint(loader._coords.x * 256, loader._coords.y * 256);

    point.x -= lt.x;
    point.y -= lt.y;
  } else {
    point = toPoint(0, 0);
  }

  var pow2_8 = Math.pow(2, 8);
  var pow2_16 = Math.pow(2, 16);
  var pow2_23 = Math.pow(2, 23);
  var pow2_24 = Math.pow(2, 24);

  var demData = loader._demData ? loader._demData : [];

  var canvas = getCanvas();
  var ctx = canvas.getContext("2d");
  ctx.drawImage(loader._demImage, 0, 0, 256, 256);
  var data = ctx.getImageData(0, 0, 256, 256).data;
  var hasErrorPixel = false;

  for (var y = 0; y < 256; ++y) {
    for (var x = 0; x < 256; ++x) {
      if (!loader._demData || loader._demData[destIdx] == null) {
        if (scale != 1) {
          var x2 = Math.floor((point.x + x) / scale);
          var y2 = Math.floor((point.y + y) / scale);
          idx = y2 * 256 * 4 + x2 * 4;
        } else idx = y * 256 * 4 + x * 4;

        var r = data[idx + 0];
        var g = data[idx + 1];
        var b = data[idx + 2];
        var h = 0;
        if (r != 128 || g != 0 || b != 0) {
          var d = r * pow2_16 + g * pow2_8 + b;
          h = d < pow2_23 ? d : d - pow2_24;
          if (h == -pow2_23) h = 0;
          else h *= 0.01;
          demData[destIdx] = h;
        } else {
          hasErrorPixel = true;
          demData[destIdx] = null;
        }
      }

      destIdx++;
    }
  }

  if (loader._demData) hasErrorPixel = false;
  loader._demData = demData;

  if (hasErrorPixel && targetUrl.complementList) {
    // DEM5aなどの境目補完
    // urlリストを補完用に変更
    // loader._urlList = global.$.extend(true, [], targetUrl.complementList);
    loader._urlList = Object.assign([], targetUrl.complementList);
    _startLoadDEM(loader);
  } else {
    loader._demLoaded = true;
    _checkLoaded(loader);
  }
}

var _canvas;

// 標高png読み取り用Canvas
function getCanvas() {
  if (!_canvas) {
    _canvas = document.createElement("canvas");
    _canvas.width = 256;
    _canvas.height = 256;
  }
  return _canvas;
}

var DEMLoadFunc_DEMAREA = {};
var DEMLoadFunc_DEMAREA2 = {};
var DEMLoadFunc_DEMAREA3 = {};
for (var i = 0; i < CONFIG_DEMAREA.length; i++) {
  DEMLoadFunc_DEMAREA[CONFIG_DEMAREA[i]] = 1;
}
for (var i2 = 0; i2 < CONFIG_DEMAREA2.length; i2++) {
  DEMLoadFunc_DEMAREA2[CONFIG_DEMAREA2[i2]] = 1;
}
for (var i3 = 0; i3 < CONFIG_DEMAREA3.length; i3++) {
  DEMLoadFunc_DEMAREA3[CONFIG_DEMAREA3[i3]] = 1;
}

/**
 * タイル座標から標高タイルURLを決定
 * @param {*} x
 * @param {*} y
 * @param {*} z
 */
function getURLList(x, y, z) {
  //-------------------------------------------------------------------------------
  var getCoords = function getCoords(x, y, z, targetZoom) {
    var scale = Math.pow(2, z - targetZoom);
    var point = _floor(
      divideBy(toPoint((x * 256) / scale, (y * 256) / scale), 256)
    );
    return {
      x: point.x,
      y: point.y,
      z: targetZoom,
    };
  };
  var coordsToKey = function coordsToKey(coords) {
    return coords.z + "/" + coords.x + "/" + coords.y;
  };
  //-------------------------------------------------------------------------------

  // ZL8以下はdem_gm
  if (z <= 8)
    return [
      {
        url: "https://cyberjapandata.gsi.go.jp/xyz/demgm_png/{z}/{x}/{y}.png",
        minZoom: 0,
        maxZoom: 14,
      },
    ];

  // ZL9以上
  var key = null;

  // DEMAREAになけれdem_gm
  key = coordsToKey(getCoords(x, y, z, 8));
  if (!DEMLoadFunc_DEMAREA[key])
    return [
      {
        url: "https://cyberjapandata.gsi.go.jp/xyz/demgm_png/{z}/{x}/{y}.png",
        minZoom: 0,
        maxZoom: 14,
      },
    ];

  // DEMAREA2になければdem
  key = coordsToKey(getCoords(x, y, z, 9));
  if (!DEMLoadFunc_DEMAREA2[key])
    return [
      {
        url: "https://cyberjapandata.gsi.go.jp/xyz/dem5a_png/{z}/{x}/{y}.png",
        minZoom: 15,
        maxZoom: 15,
        complementList: [
          {
            url:
              "https://cyberjapandata.gsi.go.jp/xyz/dem5b_png/{z}/{x}/{y}.png",
            minZoom: 15,
            maxZoom: 15,
          },
        ],
      },
      {
        url: "https://cyberjapandata.gsi.go.jp/xyz/dem5b_png/{z}/{x}/{y}.png",
        minZoom: 15,
        maxZoom: 15,
        complementList: [],
      },
    ];

  key = coordsToKey(getCoords(x, y, z, 10));
  if (!DEMLoadFunc_DEMAREA3[key] == -1) {
    // DEMAREA2にあって、DEMAREA3になければdemgm
    return [
      {
        url: "https://cyberjapandata.gsi.go.jp/xyz/demgm_png/{z}/{x}/{y}.png",
        minZoom: 0,
        maxZoom: 8,
      },
    ];
  } else {
    // DEMAREA2にあって、DEMAREA3にあればdem
    return [
      {
        url: "https://cyberjapandata.gsi.go.jp/xyz/dem_png/{z}/{x}/{y}.png",
        minZoom: 0,
        maxZoom: 14,
        complementList: [
          {
            url:
              "https://cyberjapandata.gsi.go.jp/xyz/demgm_png/{z}/{x}/{y}.png",
            minZoom: 0,
            maxZoom: 8,
          },
        ],
      },
    ];
  }
}

// URL生成
function getDEMTileUrl(url, coords) {
  // replaceでx,y,zを置換
  var result = url.replace("{x}", coords.x);
  result = result.replace("{y}", coords.y);
  result = result.replace("{z}", coords.z);

  return result;
}

/**
 * 指定のタイルが無い場合一つ上のズーム
 */
function _nextZoom(loader, self) {
  var options = {
    minZoom: 8,
    overZooming: true,
    useHillshademap: false,
    tms: false,
  };

  var nextZoom = loader._currentCoords.z - 1;
  if (nextZoom < options.minZoom) {
    _demLoadError(loader);
    return;
  }

  var scale = Math.pow(2, loader._coords.z - nextZoom);
  var point = _floor(
    divideBy(
      toPoint(
        (loader._coords.x * 256) / scale,
        (loader._coords.y * 256) / scale
      ),
      256
    )
  );
  loader._currentCoords = {
    x: point.x,
    y: point.y,
    z: nextZoom,
  };

  _startLoadDEM(loader, self);
}

/**
 * 読み込み開始
 * @param {*} loader
 * @param {*} self
 */
function _startLoadDEM(loader, self) {
  // var urlList = global.$.extend(true, [], loader._urlList);
  var urlList = Object.assign([], loader._urlList);
  _loadDEM(urlList, loader._currentCoords, loader, self);
}

// 読み込み完了チェック
function _checkLoaded(loader) {
  var options = {
    minZoom: 8,
    overZooming: true,
    useHillshademap: false,
    tms: false,
  };

  if (
    loader._demLoaded &&
    (!options.useHillshademap || loader._hillshademapLoaded)
  ) {
    loader.onLoadfunc(loader);
  }
}

// ==========================

var _typeof =
  typeof Symbol === "function" && typeof Symbol.iterator === "symbol"
    ? function(obj) {
        return typeof obj;
      }
    : function(obj) {
        return obj &&
          typeof Symbol === "function" &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? "symbol"
          : typeof obj;
      };

var errorMess = {
  ph2: {
    /*
        "ER001": "Failed cross-section drawing. Error code: ER001",
        "ER002": "Failed cross-section drawing. Error code: ER002",
        "ER003": "Failed cross-section drawing. Error code: ER003"
        */
    ER001: "横断図の描画に失敗しました。",
    ER002: "河川情報の取得に失敗しました。",
    ER003: "標高データの取得に失敗しました。",
  },
  swin: {
    ER001: "横断図の描画に失敗しました。",
    ER002: "河川情報の取得に失敗しました。",
    ER003: "標高データの取得に失敗しました。",
  },
  allStageNull: "観測値がないため、水位を描画できません",
};

function getErrorMsg(sys, code) {
  return errorMess[sys][code] || "横断図の描画に失敗しました。";
}

// undefined・null・false・空配列・空オブジェクト・空文字・スペースのみはtrue
function isEmpty(value) {
  if (value === undefined) return true;
  if (value === null) return true;
  if (value === false) return true;
  if (value === true) return false;
  if (typeof value === "object") return value.length === 0;
  if (typeof value === "string") return value.replace(/\s+/gi, "").length === 0;
  if (typeof value === "number") return false;
  if (typeof value === "function") return false;
}

var isArray =
  Array.isArray ||
  function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  };

function convertToPoints(x, y, round) {
  return {
    x: round ? Math.round(x) : x,
    y: round ? Math.round(y) : y,
  };
}

function toPoint(x, y, round) {
  if (isArray(x)) return convertToPoints(x[0], x[1]);
  if (isEmpty(x)) return x;
  if (
    (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object" &&
    "x" in x &&
    "y" in x
  )
    return convertToPoints(x.x, x.y);
  return convertToPoints(x, y, round);
}

function Bounds(a, b) {
  if (!a) return;
  var points = b ? [a, b] : a;
  for (var i = 0, len = points.length; i < len; i++) {
    this.extend(points[i]);
  }
}

Bounds.prototype = {
  extend: function extend(point) {
    point = toPoint(point);

    if (!this.min && !this.max) {
      this.min = convertToPoints(point.x, point.y);
      this.max = convertToPoints(point.x, point.y);
    } else {
      this.min.x = Math.min(point.x, this.min.x);
      this.max.x = Math.max(point.x, this.max.x);
      this.min.y = Math.min(point.y, this.min.y);
      this.max.y = Math.max(point.y, this.max.y);
    }
    return this;
  },
};

function makeSObj() {
  var s = 0.5 / (Math.PI * 6378137);
  return {
    _a: s,
    _b: 0.5,
    _c: -s,
    _d: 0.5,
  };
}

function transform(points, scale) {
  scale = scale || 1;
  var sObj = makeSObj();
  return {
    x: scale * (sObj._a * points.x + sObj._b),
    y: scale * (sObj._c * points.y + sObj._d),
  };
}

function divideBy(p, num) {
  var point = p;
  convertToPoints(point.x, point.y);
  point.x /= num;
  point.y /= num;
  return point;
}

function _floor(p) {
  p.x = Math.floor(p.x);
  p.y = Math.floor(p.y);
  return p;
}

function _ceil(p) {
  p.x = Math.ceil(p.x);
  p.y = Math.ceil(p.y);
  return p;
}

function _subtract(ceil, point) {
  ceil.x -= point.x;
  ceil.y -= point.y;
  return ceil;
}

function getProjectedBounds(zoom) {
  zoom = zoom || 18;
  var b = bounds(),
    s = 256 * Math.pow(2, zoom);
  return new Bounds(transform(b.min, s), transform(b.max, s));
}

function bounds() {
  var d = 6378137 * Math.PI;
  return new Bounds([-d, -d], [d, d]);
}

function _pxBoundsToTileRange(bounds) {
  var tileSize = convertToPoints(256, 256);
  var unscale = unscaleBy(bounds.max, tileSize);
  return new Bounds(
    _floor(unscale),
    _subtract(_ceil(unscale), {
      x: 1,
      y: 1,
    })
  );
}

function unscaleBy(bounds, point) {
  return convertToPoints(bounds.x / point.x, bounds.y / point.y);
}
